export interface PanelProps {
    heading: React.ReactNode;
    id: string;
    children: React.ReactNode;
    disabled?: boolean;
    onChange?: (
        panel: React.ReactElement<PanelProps>,
        expanded: boolean
    ) => void;
    hideExpandIcon?: boolean;
    customExpandedHeader?: React.ReactNode;
    customExpandedClassName?: string;
    expanded?: boolean;
}

export const Panel = (props: PanelProps) => null;
